import { useQuery } from "react-query";
import ShippingService from "../api/services/ShippingService";

export const useShippingMethods = (queryKey: string | null, stateCode: string | null = null) => {
  const { data, isLoading, refetch, error } = useQuery(`${queryKey}_shippingMethods`, async () =>
    await ShippingService.getShippingMethods(queryKey, stateCode)
  );

  return {
    shippingMethods: data?.data?.methods,
    isShippingMethodsLoading: isLoading,
    shippingMethodsError: error,
    fetchShippingMethods: refetch
  }
}
